export default "__VITE_PUBLIC_ASSET__e1717b96__"